import { MediumIcon } from "../IconSizes";

export const stenaBusinessAgreement: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M15.48 0C16.86 0 18 1.1 18 2.5L18 7 21.48 7C22.86 7 24 8.1 24 9.5L23.98 20.65 23.96 20.79C23.69 22.64 22.08 24 20.19 24L3.5 24C1.57 24 0 22.43 0 20.5L0 2.5C0 1.16 1.05 0.09 2.35 0.01L2.52 0 15.48 0ZM15.48 2L2.52 2C2.23 2 2 2.22 2 2.5L2 20.5C2 21.33 2.67 22 3.5 22L16.51 22C16.19 21.5 16 20.89 16 20.25L16 2.5C16 2.22 15.77 2 15.48 2ZM21.48 9L17.99 9 17.99 17 18 17 18 20C18 21.1 18.9 22 20 22 21.1 22 22 21.1 22 20L22 9.5C22 9.22 21.77 9 21.48 9ZM12 18C12.55 18 13 18.45 13 19 13 19.55 12.55 20 12 20L8 20C7.45 20 7 19.55 7 19 7 18.45 7.45 18 8 18L12 18Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaBusinessArticle: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M19 0C20.63 0 22 1.34 22 3L22 21C22 22.66 20.63 24 19 24L5 24C3.37 24 2 22.66 2 21L2 3C2 1.34 3.37 0 5 0L19 0ZM19 2L5 2C4.46 2 4 2.45 4 3L4 21C4 21.55 4.46 22 5 22L19 22C19.54 22 20 21.55 20 21L20 3C20 2.45 19.54 2 19 2Z M14.11 6.55C14.35 6.06 14.95 5.86 15.45 6.11 15.94 6.35 16.14 6.95 15.89 7.45 15.06 9.11 13.73 10 12 10 10.27 10 8.94 9.11 8.11 7.45 7.86 6.95 8.06 6.35 8.55 6.11 9.05 5.86 9.65 6.06 9.89 6.55 10.4 7.56 11.06 8 12 8 12.94 8 13.6 7.56 14.11 6.55Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaBusinessCard: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M21 3C22.66 3 24 4.34 24 6L24 18C24 19.66 22.66 21 21 21L3 21C1.34 21 0 19.66 0 18L0 6C0 4.34 1.34 3 3 3L21 3ZM22 10L2 10 2 18C2 18.55 2.45 19 3 19L21 19C21.55 19 22 18.55 22 18L22 10ZM19 15C19.55 15 20 15.45 20 16 20 16.55 19.55 17 19 17L16 17C15.45 17 15 16.55 15 16 15 15.45 15.45 15 16 15L19 15ZM21 5L3 5C2.45 5 2 5.45 2 6L2 8 22 8 22 6C22 5.45 21.55 5 21 5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaBusinessClaim: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M20.42-0.1C21.9 0.11 23 1.37 23 2.87L22 16.29C22 17.24 21.55 18.13 20.79 18.69L13.79 23.16C12.73 23.95 11.27 23.95 10.21 23.16L3.21 18.69C2.45 18.13 2 17.24 2 16.29L1 2.87C1 1.37 2.1 0.11 3.58-0.1L20.42-0.1ZM20.14 1.88L3.86 1.88C3.37 1.95 3 2.37 3 2.87L4 16.29C4 16.6 4.15 16.9 4.4 17.09L11.4 21.56C11.72 21.79 12.15 21.82 12.49 21.63L19.6 17.09C19.85 16.9 20 16.6 20 16.29L21 2.87C21 2.37 20.63 1.95 20.14 1.88ZM12 15C12.55 15 13 15.45 13 16 13 16.55 12.55 17 12 17 11.45 17 11 16.55 11 16 11 15.45 11.45 15 12 15ZM12 5C12.55 5 13 5.45 13 6L13 12C13 12.55 12.55 13 12 13 11.45 13 11 12.55 11 12L11 6C11 5.45 11.45 5 12 5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaBusinessInvoice: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M19 0C20.66 0 22 1.34 22 3L22 21C22 22.66 20.66 24 19 24L5 24C3.34 24 2 22.66 2 21L2 3C2 1.34 3.34 0 5 0L19 0ZM19 2L5 2C4.45 2 4 2.45 4 3L4 21C4 21.55 4.45 22 5 22L19 22C19.55 22 20 21.55 20 21L20 3C20 2.45 19.55 2 19 2ZM17 18C17.55 18 18 18.45 18 19 18 19.55 17.55 20 17 20L15 20C14.45 20 14 19.55 14 19 14 18.45 14.45 18 15 18L17 18ZM13 8C13.55 8 14 8.45 14 9 14 9.55 13.55 10 13 10L7 10C6.45 10 6 9.55 6 9 6 8.45 6.45 8 7 8L13 8ZM13 4C13.55 4 14 4.45 14 5 14 5.55 13.55 6 13 6L7 6C6.45 6 6 5.55 6 5 6 4.45 6.45 4 7 4L13 4Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaBusinessNslh: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M19 0C20.66 0 22 1.34 22 3L22 21C22 22.66 20.66 24 19 24L5 24C3.34 24 2 22.66 2 21L2 3C2 1.34 3.34 0 5 0L19 0ZM19 2L5 2C4.45 2 4 2.45 4 3L4 21C4 21.55 4.45 22 5 22L19 22C19.55 22 20 21.55 20 21L20 3C20 2.45 19.55 2 19 2ZM15 17C15.83 17 16.5 17.67 16.5 18.5 16.5 19.33 15.83 20 15 20 14.17 20 13.5 19.33 13.5 18.5 13.5 17.67 14.17 17 15 17ZM15 9C15.55 9 16 9.39 16 9.88L16 15.13C16 15.61 15.55 16 15 16 14.45 16 14 15.61 14 15.13L14 9.88C14 9.39 14.45 9 15 9Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaBusinessSignature: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M19.98 0.68C21.18 1 22.12 1.94 22.44 3.14 22.76 4.34 22.42 5.62 21.54 6.5L6.94 21.1C6.81 21.23 6.65 21.32 6.48 21.36L1.8 22.53C1.07 22.71 0.41 22.05 0.59 21.32L1.76 16.65C1.8 16.47 1.89 16.31 2.02 16.18L16.62 1.58C17.5 0.7 18.78 0.36 19.98 0.68ZM21 20.12C21.55 20.12 22 20.57 22 21.12 22 21.67 21.55 22.12 21 22.12L12 22.12C11.45 22.12 11 21.67 11 21.12 11 20.57 11.45 20.12 12 20.12L21 20.12ZM18.04 2.99L3.63 17.4 2.93 20.19 5.72 19.49 20.13 5.08C20.46 4.75 20.62 4.27 20.54 3.81L20.51 3.66C20.37 3.15 19.98 2.75 19.47 2.61 18.96 2.47 18.41 2.62 18.04 2.99Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaFinancePaid: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M23.68 14.32C24.11 14.76 24.11 15.46 23.68 15.89L17.01 22.68C16.78 22.91 16.47 23.02 16.16 23 15.86 23.02 15.54 22.91 15.31 22.68L10.82 18.11C10.39 17.68 10.39 16.97 10.82 16.54 11.24 16.11 11.93 16.11 12.36 16.54L16.16 20.41 22.14 14.32C22.57 13.89 23.26 13.89 23.68 14.32ZM21 3C22.66 3 24 4.34 24 6L24 11C24 11.55 23.55 12 23 12 22.45 12 22 11.55 22 11L22 10 2 10 2 18C2 18.55 2.45 19 3 19L8 19C8.55 19 9 19.45 9 20 9 20.55 8.55 21 8 21L3 21C1.34 21 0 19.66 0 18L0 6C0 4.34 1.34 3 3 3L21 3ZM21 5L3 5C2.45 5 2 5.45 2 6L2 8 22 8 22 6C22 5.45 21.55 5 21 5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaFinancePay: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M18 12C18.55 12 19 12.45 19 13L19 17 23 17C23.55 17 24 17.45 24 18 24 18.55 23.55 19 23 19L19 19 19 23C19 23.55 18.55 24 18 24 17.45 24 17 23.55 17 23L17 19 13 19C12.45 19 12 18.55 12 18 12 17.45 12.45 17 13 17L17 17 17 13C17 12.45 17.45 12 18 12ZM24 12C24 12.55 23.55 13 23 13 22.45 13 22 12.55 22 12L22 10 2 10 2 18C2 18.55 2.45 19 3 19L9 19C9.55 19 10 19.45 10 20 10 20.55 9.55 21 9 21L3 21C1.34 21 0 19.66 0 18L0 6C0 4.34 1.34 3 3 3L21 3C22.66 3 24 4.34 24 6L24 12ZM21 5L3 5C2.45 5 2 5.45 2 6L2 8 22 8 22 6C22 5.45 21.55 5 21 5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaFinancePayPartially: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M18 12C21.31 12 24 14.69 24 18 24 21.31 21.31 24 18 24 17.45 24 17 23.55 17 23 17 22.45 17.45 22 18 22 20.21 22 22 20.21 22 18 22 15.79 20.21 14 18 14 15.79 14 14 15.79 14 18 14 18.55 13.55 19 13 19 12.45 19 12 18.55 12 18 12 14.69 14.69 12 18 12ZM21 3C22.66 3 24 4.34 24 6L24 11C24 11.55 23.55 12 23 12 22.45 12 22 11.55 22 11L22 10 2 10 2 18C2 18.55 2.45 19 3 19L9 19C9.55 19 10 19.45 10 20 10 20.55 9.55 21 9 21L3 21C1.34 21 0 19.66 0 18L0 6C0 4.34 1.34 3 3 3L21 3ZM21 5L3 5C2.45 5 2 5.45 2 6L2 8 22 8 22 6C22 5.45 21.55 5 21 5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaFinanceRaise: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M13.57 8.22L15.77 10.32C16.08 10.62 16.08 11.1 15.77 11.4 15.45 11.7 14.95 11.7 14.63 11.4L13.8 10.6 13.8 22.2C13.8 22.64 13.44 23 13 23 12.56 23 12.2 22.64 12.2 22.2L12.2 10.63 12.2 10.6 11.37 11.4C11.07 11.68 10.6 11.7 10.29 11.44L10.23 11.4C9.92 11.1 9.92 10.62 10.23 10.32L12.43 8.22C12.75 7.93 13.25 7.93 13.57 8.22ZM18.76 1.4L23 3.86C23.62 4.22 24 4.9 24 5.63L23.98 10.59C23.97 11.67 23.41 12.66 22.49 13.2L17.45 16.13C16.97 16.41 16.36 16.24 16.08 15.77 15.8 15.29 15.97 14.68 16.45 14.4L21.48 11.45C21.79 11.27 21.98 10.94 21.98 10.58L22 5.6 17.76 3.13C17.46 2.95 17.08 2.96 16.77 3.14L2.5 11.55C2.02 11.82 1.86 12.44 2.13 12.93L5.85 19.49C6.12 19.98 6.73 20.14 7.2 19.86L9.57 18.48C10.05 18.2 10.66 18.37 10.93 18.85 11.21 19.32 11.05 19.94 10.57 20.21L8.19 21.59C6.77 22.43 4.94 21.93 4.12 20.49L0.4 13.93C-0.42 12.48 0.07 10.63 1.49 9.8L15.79 1.41C16.71 0.87 17.84 0.86 18.76 1.4ZM18.5 6C19.33 6 20 6.67 20 7.5 20 8.33 19.33 9 18.5 9 17.67 9 17 8.33 17 7.5 17 6.67 17.67 6 18.5 6Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaFinanceRebate: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M10.05 1.1C10.33 1.18 10.6 1.3 10.85 1.47L11.03 1.6C11.58 2.04 12.35 2.05 12.88 1.67L12.96 1.61C14.15 0.66 15.88 0.84 16.83 2.03 17.01 2.26 17.16 2.52 17.26 2.8L17.33 3.01C17.51 3.69 18.13 4.16 18.8 4.16L18.89 4.16C20.41 4.09 21.7 5.25 21.76 6.77 21.78 7.07 21.74 7.37 21.66 7.65L21.59 7.86C21.35 8.52 21.57 9.26 22.1 9.65L22.18 9.7C23.45 10.54 23.81 12.24 22.97 13.51 22.81 13.76 22.61 13.98 22.37 14.16L22.19 14.29C21.61 14.68 21.35 15.41 21.56 16.04L21.59 16.13C22.12 17.55 21.41 19.14 19.99 19.67 19.71 19.78 19.42 19.83 19.12 19.84L18.9 19.84C18.2 19.81 17.56 20.26 17.36 20.89L17.33 20.97C16.93 22.44 15.42 23.31 13.95 22.9 13.67 22.82 13.4 22.7 13.15 22.53L12.97 22.4C12.42 21.96 11.65 21.95 11.12 22.33L11.04 22.39C9.85 23.34 8.12 23.16 7.17 21.97 6.99 21.74 6.84 21.48 6.74 21.2L6.67 20.99C6.49 20.31 5.87 19.84 5.2 19.84L5.11 19.84C3.59 19.91 2.3 18.75 2.24 17.23 2.22 16.93 2.26 16.63 2.34 16.35L2.41 16.14C2.65 15.48 2.43 14.74 1.9 14.35L1.82 14.3C0.55 13.46 0.19 11.76 1.03 10.49 1.19 10.24 1.39 10.02 1.63 9.84L1.81 9.71C2.39 9.32 2.65 8.59 2.44 7.96L2.41 7.87C1.88 6.45 2.59 4.86 4.01 4.33 4.29 4.22 4.58 4.17 4.88 4.16L5.1 4.16C5.8 4.19 6.44 3.74 6.64 3.11L6.67 3.01 6.72 2.86C7.19 1.5 8.64 0.71 10.05 1.1ZM8.6 3.56L8.56 3.69C8.07 5.21 6.61 6.23 5.01 6.15 4.91 6.15 4.81 6.17 4.72 6.2 4.33 6.35 4.14 6.77 4.29 7.17L4.33 7.3C4.83 8.83 4.25 10.5 2.91 11.38 2.82 11.44 2.75 11.51 2.7 11.59 2.47 11.93 2.57 12.39 2.92 12.63L3.04 12.71C4.33 13.65 4.84 15.34 4.28 16.84 4.25 16.94 4.23 17.04 4.23 17.14 4.25 17.55 4.6 17.86 5.02 17.84L5.16 17.84C6.76 17.84 8.17 18.91 8.6 20.46 8.63 20.55 8.67 20.64 8.74 20.72 8.99 21.04 9.46 21.09 9.79 20.83L9.91 20.74C11.2 19.8 12.97 19.84 14.22 20.84 14.3 20.9 14.39 20.95 14.49 20.97 14.88 21.08 15.29 20.85 15.4 20.44L15.44 20.31C15.93 18.79 17.39 17.77 18.99 17.85 19.09 17.85 19.19 17.83 19.28 17.8 19.67 17.65 19.86 17.23 19.71 16.83L19.67 16.7C19.17 15.17 19.75 13.5 21.09 12.62 21.18 12.56 21.25 12.49 21.3 12.41 21.53 12.07 21.43 11.61 21.08 11.37L20.96 11.29C19.67 10.35 19.16 8.66 19.72 7.16 19.75 7.06 19.77 6.96 19.77 6.86 19.75 6.45 19.4 6.14 18.98 6.16L18.84 6.16C17.24 6.16 15.83 5.09 15.4 3.54 15.37 3.45 15.33 3.36 15.26 3.28 15.01 2.96 14.54 2.91 14.21 3.17L14.09 3.26C12.8 4.2 11.03 4.16 9.78 3.16 9.7 3.1 9.61 3.05 9.51 3.03 9.12 2.92 8.71 3.15 8.6 3.56ZM12 7C14.76 7 17 9.24 17 12 17 14.76 14.76 17 12 17 9.24 17 7 14.76 7 12 7 9.24 9.24 7 12 7ZM12 9C10.34 9 9 10.34 9 12 9 13.66 10.34 15 12 15 13.66 15 15 13.66 15 12 15 10.34 13.66 9 12 9Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaFinanceUnpaid: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M15.59 14.17L19 17.59 22.41 14.17C22.8 13.78 23.44 13.78 23.83 14.17 24.22 14.56 24.22 15.2 23.83 15.59L20.41 19 23.83 22.41C24.22 22.8 24.22 23.44 23.83 23.83 23.44 24.22 22.8 24.22 22.41 23.83L19 20.41 15.59 23.83C15.2 24.22 14.56 24.22 14.17 23.83 13.78 23.44 13.78 22.8 14.17 22.41L17.59 19 14.17 15.59C13.78 15.2 13.78 14.56 14.17 14.17 14.56 13.78 15.2 13.78 15.59 14.17ZM21 3C22.66 3 24 4.34 24 6L24 11C24 11.55 23.55 12 23 12 22.45 12 22 11.55 22 11L22 10 2 10 2 18C2 18.55 2.45 19 3 19L10.2 19 10.2 19.02C10.66 19.11 11 19.52 11 20 11 20.55 10.55 21 10 21L3 21C1.34 21 0 19.66 0 18L0 6C0 4.34 1.34 3 3 3L21 3ZM21 5L3 5C2.45 5 2 5.45 2 6L2 8 22 8 22 6C22 5.45 21.55 5 21 5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaFinanceUnpaidAlt: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M19 0.61C19.48 0.88 19.64 1.5 19.37 1.97L6.37 23.03C6.09 23.5 5.48 23.67 5 23.39 4.52 23.12 4.36 22.5 4.63 22.03L17.63 0.97C17.91 0.5 18.52 0.33 19 0.61ZM14.04 3L12.89 5 3 5C2.45 5 2 5.45 2 6L2 9 10.58 9 9.42 11 2 11 2 18C2 18.55 2.45 19 3 19L4.8 19 3.65 21 3 21C1.34 21 0 19.66 0 18L0 6C0 4.34 1.34 3 3 3L14.04 3ZM21 3C22.66 3 24 4.34 24 6L24 18C24 19.66 22.66 21 21 21L9.96 21 11.11 19 21 19C21.55 19 22 18.55 22 18L22 11 15.73 11 16.89 9 22 9 22 6C22 5.45 21.55 5 21 5L19.2 5 20.35 3 21 3Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaFinanceWallet: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M17.17 0.18L19.11 6 19.51 6C20.92 6 22 7.16 22 8.52L22 12 23 12C23.55 12 24 12.45 24 13L24 17C24 17.55 23.55 18 23 18L22 18 22 20.48C22 21.84 20.92 23 19.51 23L2.49 23C1.08 23 0 21.84 0 20.48L0 8.52C0 7.16 1.08 6 2.49 6L5.53 6 17.17 0.18ZM19.51 8L2.49 8C2.22 8 2 8.23 2 8.52L2 20.48C2 20.77 2.22 21 2.49 21L19.51 21C19.78 21 20 20.77 20 20.48L20 18C18.34 18 17 16.66 17 15 17 13.4 18.25 12.1 19.82 12.01L20 12 20 8.52C20 8.23 19.78 8 19.51 8ZM22 14L20 14C19.45 14 19 14.45 19 15 19 15.55 19.45 16 20 16L22 16 22 14ZM16 3L10 6 17 6 16 3Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};
